import React from "react";
import { Link } from "react-router-dom";

const MenuEnsinoEspecial = ({ inicioUrl, menuOpcaoAtivo, acessos }) => {
    return (
        <div className="menu-detalhe-curso menu-detalhe-curso-v2">
            <div className="container">
                <ul>
                    {acessos?.includes(16) && (
                        <li>
                            <Link
                                to={`${inicioUrl}/visao-geral-disciplina`}
                                className={menuOpcaoAtivo === "visao-geral-disciplina" ? "ativo" : ""}
                            >
                                Visão Geral
                            </Link>
                        </li>
                    )}
                    {acessos?.includes(17) && (
                        <li>
                            <Link
                                to={`${inicioUrl}/atendimentos-aluno`}
                                className={
                                    menuOpcaoAtivo === "atendimentos-aluno" ||
                                    menuOpcaoAtivo === "horario-detalhe" ||
                                    menuOpcaoAtivo === "diario-folha-conteudos" ||
                                    menuOpcaoAtivo === "diario-folha-frequencia" ||
                                    menuOpcaoAtivo === "diario-folha-observacoes" ||
                                    menuOpcaoAtivo === "diario-folha-pareceres" ||
                                    menuOpcaoAtivo === "relatorios-atendimento"
                                        ? "ativo"
                                        : ""
                                }
                            >
                                Diário
                            </Link>
                        </li>
                    )}
                    {acessos?.includes(33) && (
                        <li>
                            <Link to={`${inicioUrl}/sala-regular`} className={menuOpcaoAtivo === "sala-regular" ? "ativo" : ""}>
                                Sala Regular
                            </Link>
                        </li>
                    )}
                    <li>
                        <Link to={`${inicioUrl}/estudos-de-caso`} className={menuOpcaoAtivo === "estudos-de-caso" ? "ativo" : ""}>
                            Estudos de Caso
                        </Link>
                    </li>
                    <li>
                        <Link
                            to={`${inicioUrl}/planos-de-atendimento`}
                            className={menuOpcaoAtivo === "planos-de-atendimento" ? "ativo" : ""}
                        >
                            Planos de Atendimento
                        </Link>
                    </li>
                    <li>
                        <Link
                            to={`${inicioUrl}/relatorios-individuais`}
                            className={menuOpcaoAtivo === "relatorios-individuais" ? "ativo" : ""}
                        >
                            Relatório Individual
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default MenuEnsinoEspecial;
